import styled from 'styled-components'
import { Theme } from '../../Theme';

const Content = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    .BannerArea {
        background-color: ${Theme.FIRST_COLOR};
        display: flex;
        align-items: center;
        justify-content: center;
        height: 31vh;
        min-height: 250px;

        .BannerFixed {
            width: 40%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                height: 80%;
                max-width: 100%;
                object-fit: contain;
            }
        }

        .ImgCarrousel {
            width: 60%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            overflow: hidden;
            position: relative;

            .CarrouselContainer {
                display: flex;
                height: 100%;
                transition: transform 0.5s ease-in-out;
                width: 400%; /* 4 imagens * 100% */

                img {
                    width: 25%; /* 100% / 4 imagens */
                    height: 100%;
                    object-fit: cover;
                    flex-shrink: 0;
                    border-left: 3px solid ${Theme.THIRD_COLOR};
                }
            }
        }
    }

    .InfoArea {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
        padding: 40px 20px;
        justify-content: center;
        max-width: 1200px;
        margin: 0 auto;

        .Card {
            padding: 30px;
            background-color: ${Theme.THIRD_COLOR};
            border-radius: 10px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

            .Title {
                display: block;
                font-size: 24px;
                font-weight: bold;
                color: ${Theme.FIRST_COLOR};
                margin-bottom: 15px;
            }

            p {
                font-size: 16px;
                line-height: 1.6;
                color: #333;
                text-align: justify;
            }

            ul {
                list-style: none;
                padding: 0;
                margin: 0;

                li {
                    font-size: 16px;
                    line-height: 1.8;
                    color: #333;
                    margin-bottom: 12px;
                    padding-left: 25px;
                    position: relative;

                    &::before {
                        content: "●";
                        color: ${Theme.FIRST_COLOR};
                        font-size: 20px;
                        position: absolute;
                        left: 0;
                        top: -2px;
                    }

                    strong {
                        font-weight: 600;
                        color: #000;
                    }
                }
            }

            &.AreasCard {
                .ProfissoesImage {
                    width: 100%;
                    display: flex;
                    justify-content: center;

                    img {
                        max-width: 100%;
                        height: auto;
                        border-bottom: solid 3px ${Theme.FIRST_COLOR};
                    }
                }

                .AreasGrid {
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    gap: 10px;
                    flex-wrap: nowrap;

                    .AreaItem {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 8px;
                        flex: 0 1 auto;

                        img {
                            width: 50px;
                            height: 50px;
                            object-fit: contain;
                        }

                        span {
                            font-size: 13px;
                            font-weight: 500;
                            color: ${Theme.FIRST_COLOR};
                            text-align: center;
                            word-break: keep-all;
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 1200px) {
        .BannerArea {
            .ImgCarrousel .CarrouselContainer {
                width: 200%; /* 2 imagens * 100% */
                
                img {
                    width: 50%; /* 100% / 2 imagens */
                }
            }
        }

        .InfoArea {
            padding: 30px 15px;
            gap: 15px;
        }
    }

    @media (max-width: 900px) {
        .BannerArea {
            .ImgCarrousel .CarrouselContainer {
                width: 300%; /* 3 imagens * 100% */
                
                img {
                    width: 33.333%; /* 100% / 3 imagens */
                }
            }
        }
    }

    @media (max-width: 768px) {
        .BannerArea {
            flex-direction: row;
            height: 250px;
            min-height: auto;

            .BannerFixed {
                width: 50%;
                height: 100%;
                padding: 10px;
                
                img {
                    height: 80%;
                    max-height: none;
                }
            }

            .ImgCarrousel {
                width: 50%;
                height: 100%;

                .CarrouselContainer {
                    width: 400%; /* 4 imagens * 100% = 400% */
                    
                    img {
                        width: 100%; /* Cada imagem ocupa 100% do ImgCarrousel (50% da tela) */
                        min-width: 100%;
                        border-left: 3px solid ${Theme.THIRD_COLOR};
                        border-top: none;
                    }
                }
            }
        }

        .InfoArea {
            grid-template-columns: 1fr;
            padding: 20px 15px;
            gap: 15px;

            .Card {
                &.AreasCard {
                    .ProfissoesImage {
                        margin-bottom: 15px;
                    }

                    .AreasGrid {
                        gap: 5px;
                        justify-content: space-between;

                        .AreaItem {
                            img {
                                width: 40px;
                                height: 40px;
                            }

                            span {
                                font-size: 11px;
                            }
                        }
                    }
                }
            }
        }
    }

    /* Modal de Visualização de Imagens */
    .ImageModal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.95);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        cursor: pointer;

        img {
            max-width: 90%;
            max-height: 90vh;
            object-fit: contain;
            cursor: default;
            user-select: none;
        }

        .CloseButton {
            position: absolute;
            top: 20px;
            right: 30px;
            background: transparent;
            border: none;
            color: white;
            font-size: 45px;
            font-weight: 300;
            cursor: pointer;
            z-index: 10000;
            transition: opacity 0.3s;
            padding: 0;
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;

            &:hover {
                opacity: 0.7;
            }
        }

        .NavButton {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background: rgba(255, 255, 255, 0.2);
            border: none;
            color: white;
            font-size: 60px;
            font-weight: 300;
            cursor: pointer;
            z-index: 10000;
            transition: background 0.3s;
            padding: 10px 20px;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;
            border-radius: 5px;

            &:hover {
                background: rgba(255, 255, 255, 0.4);
            }

            &.PrevButton {
                left: 20px;
            }

            &.NextButton {
                right: 20px;
            }
        }
    }

    @media (max-width: 768px) {
        .ImageModal {
            img {
                max-width: 95%;
                max-height: 80vh;
            }

            .CloseButton {
                top: 10px;
                right: 15px;
                font-size: 35px;
                width: 40px;
                height: 40px;
            }

            .NavButton {
                font-size: 40px;
                padding: 5px 15px;
                height: 60px;

                &.PrevButton {
                    left: 10px;
                }

                &.NextButton {
                    right: 10px;
                }
            }
        }
    }
`;

export const Styled = {
    Content
}